import React from "react";

import "./index.css";

const readingPlan20262027 =
  "https://www.dropbox.com/scl/fi/jlp6fp193flhzwn7ei2me/WAC-Reading-Plan-2026-2027-PDF.pdf?rlkey=bkdftdxpxgl30dmgmqwomdk9f&st=6lzhecej&dl=1";

const studyResources =
  "https://drive.google.com/drive/folders/1qcxyWPxxjkrC_zuYCY-rkRa0n68S8uzO?usp=share_link";

function ReadingPlanForTheYear() {
  return (
    <div className="DownloadReadingPlan__component">
      <a
        href={readingPlan20262027}
        download="wearechurchreadingPDF-2026-2027"
        rel="noopener noreferrer"
      >
        <h3>2026-2027 Reading Plan PDF</h3>
      </a>
      <br />
      <a href={studyResources} rel="noopener noreferrer">
        <h3>Study Resources</h3>
      </a>
    </div>
  );
}

export default ReadingPlanForTheYear;
